import React from "react";
import { X } from "lucide-react";

interface TourModalProps {
  isOpen: boolean;
  onClose: () => void;
  onStart: () => void;
}

export const TourModal: React.FC<TourModalProps> = ({
  isOpen,
  onClose,
  onStart,
}) => {
  const handleClose = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-xs transition-opacity duration-300"
        onClick={handleClose}
      />

      {/* Modal */}
      <div className="relative w-full max-w-2xl mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 scale-100 max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-linear-to-r from-blue-50 to-indigo-50">
          <button
            onClick={handleClose}
            className="p-2 hover:bg-white/50 rounded-full transition-colors duration-200 ml-auto"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto flex-1">
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Get to Know FiBi in Under a Minute
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Watch this quick walkthrough to see how FiBi helps you interact
                smarter — from sending messages to responding with AI precision.
                Let’s show you what’s possible.
              </p>
            </div>

            {/* Video Placeholder */}
            <div className="relative aspect-video rounded-xl overflow-hidden border border-gray-200">
              <video
                src="/FiBi-workthrough.mp4"
                className="w-full h-full object-contain rounded-xl"
                autoPlay
                loop
                muted
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-center p-6 border-t border-gray-200 bg-gray-50 w-full">
          <button
            onClick={onStart}
            className="px-10 py-2 bg-[#0076E9] mx-auto text-white rounded-lg font-medium hover:bg-[#0076E9]/85 transition-all duration-200 hover:shadow-lg"
          >
            Let’s Go
          </button>
        </div>
      </div>
    </div>
  );
};
